import { createContext, type Ref } from 'react';

import type { _SelectionRef } from '../types.js';

export const SelectionAreaPathRefContext =
  createContext<Ref<_SelectionRef | null>>(null);
